module.exports = __webpack_public_path__ + "static/img/boy.1142ef1.png";


//////////////////
// WEBPACK FOOTER
// ./src/pages/suspect/images/characters/boy.png
// module id = jj2j
// module chunks = 1